import React from "react";

import {
  Routes,
  Route,
} from "react-router-dom";
import Home from "./pages/Home";
import EmiCalculator from "./pages/finance/EmiCalculator";
import TaxCalculator from "./pages/finance/TaxCalculator";
import AboutUs from "./pages/AboutUs";
import PrivacyPolicy from "./pages/PrivacyPolicy";
import ContactUs from "./pages/ContactUs";
import TermsConditions from "./pages/TermsConditions";
import AgeCalculator from "./pages/utility/AgeCalculator";
import PasswordGenerator from "./pages/utility/PasswordGenerator";
import QRGenerator from "./pages/utility/QRGenerator";
import WordCounter from "./pages/utility/WordCounter";
import JsonFormatter from "./pages/developer/JsonFormatter";
import MergePdf from "./pages/pdf/MergePdf";
import SplitPdf from "./pages/pdf/SplitPdf";
import ImageToPdf from "./pages/pdf/ImageToPdf";
import NotFound from "./pages/NotFound";
import Stopwatch from "./pages/utility/Stopwatch";
import BMICalculator from "./pages/utility/BMICalculator";
import PercentageCalculator from "./pages/utility/PercentageCalculator";
import LoanEligibility from "./pages/finance/LoanEligibility";
import JWTDecoder from "./pages/developer/JWTDecoder";
import ScrollToTop from "./components/ScrollToTop";

export default function App() {
  return (
    <>
      <ScrollToTop />
    <Routes>

      <Route
        path="/"
        element={<Home />}
      />

      <Route
        path="/emi-calculator"
        element={<EmiCalculator />}
      />

      <Route
        path="/tax-calculator"
        element={<TaxCalculator />}
      />

      <Route
        path="/about-us"
        element={<AboutUs />}
      />

      <Route
        path="/privacy-policy"
        element={<PrivacyPolicy />}
      />

      <Route
        path="/contact-us"
        element={<ContactUs />}
      />

      <Route
        path="/terms-conditions"
        element={<TermsConditions />}
      />
      <Route
  path="/age-calculator"
  element={<AgeCalculator />}
/>

<Route
  path="/password-generator"
  element={<PasswordGenerator />}
/>

<Route
  path="/qr-generator"
  element={<QRGenerator />}
/>

<Route
  path="/word-counter"
  element={<WordCounter />}
/>

<Route
  path="/json-formatter"
  element={<JsonFormatter />}
/>
<Route
  path="/merge-pdf"
  element={<MergePdf />}
/>

<Route
  path="/split-pdf"
  element={<SplitPdf />}
/>
<Route
  path="/image-to-pdf"
  element={<ImageToPdf />}
/>
<Route
  path="*"
  element={<NotFound />}
/>
<Route
  path="/stopwatch"
  element={<Stopwatch />}
/>

<Route
  path="/bmi-calculator"
  element={<BMICalculator />}
/>

<Route
  path="/percentage-calculator"
  element={<PercentageCalculator />}
/>

<Route
  path="/loan-eligibility"
  element={<LoanEligibility />}
/>

<Route
  path="/jwt-decoder"
  element={<JWTDecoder />}
/>
    </Routes>
    </>
  );
}